import React, { useEffect } from "react";
import {
  useMediaQuery,
  Toolbar,
  IconButton,
  AppBar,
  useTheme,
} from "@mui/material";
import { MdOutlineMenu, MdClose } from "react-icons/md";
import AppBarStyled from "layouts/Header/AppBarStyled";
import HeaderContent from "layouts/Header/HeaderContent";
import { dispatch } from "store";
import { getStockSettingsThunk } from "store/reducers/inventory/stock/inventorySettingsSlice";

function HeaderMain({ open, toggleMenu }) {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"));
  useEffect(() => {
    dispatch(getStockSettingsThunk())
  }, []);
  const mainHeader = (
    <Toolbar>
      <IconButton
        disableRipple
        edge="start"
        color="secondary"
        sx={{
          color: "text.primary",
          ml: { xs: 0, lg: -2 },
        }}
        onClick={toggleMenu}
      >
        {open ? <MdClose /> : <MdOutlineMenu />}
      </IconButton>
      <HeaderContent />
    </Toolbar>
  );
  const appBar = {
    position: "fixed",
    color: "inherit",
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  };
  return (
    <>
      {!matchDownMD ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}

export default HeaderMain;
